import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useReducedMotionPreference } from './ReducedMotionProvider';
import { easings, durations } from './motionTokens';

export const RouteTransition = ({ children }) => {
  const location = useLocation();
  const { prefersReducedMotion } = useReducedMotionPreference();
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    setNavigating(true);
    const timer = setTimeout(() => setNavigating(false), 380);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {/* Route Top Gold Progress Line */}
      <AnimatePresence>
        {navigating && !prefersReducedMotion && (
          <motion.div
            initial={{ scaleX: 0, opacity: 1 }}
            animate={{ scaleX: 1, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: easings.entrance }}
            className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#B99A5B] via-[#F2EEE6] to-[#B99A5B] origin-left z-[90] pointer-events-none shadow-[0_0_12px_rgba(185,154,91,0.6)]"
          />
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          initial={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 12 }}
          animate={prefersReducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
          exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
          transition={{
            duration: durations.routeEntry,
            ease: easings.entrance
          }}
          className="w-full flex-grow flex flex-col"
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default RouteTransition;
